import { render, staticRenderFns } from "./LinkDowloadExcel.vue?vue&type=template&id=68c04fe1"
import script from "./LinkDowloadExcel.vue?vue&type=script&lang=js"
export * from "./LinkDowloadExcel.vue?vue&type=script&lang=js"
import style0 from "./LinkDowloadExcel.vue?vue&type=style&index=0&id=68c04fe1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports